<template>
  <h2>Einstellungen</h2>

  <div class="card mb-4">
    <div class="card-header d-flex justify-content-between align-items-center">
      <strong>Selbstservice-Fenster</strong>
      <span v-if="!window" class="badge bg-secondary">Kein Fenster konfiguriert</span>
      <span v-else-if="window.is_open" class="badge bg-success">Geöffnet – Frist: {{ formatDate(window.deadline) }}</span>
      <span v-else class="badge bg-danger">Geschlossen</span>
    </div>
    <div class="card-body">
      <p class="text-muted small mb-3">
        Legt den Zeitraum fest, für den Abmeldungen eingetragen werden sollen, sowie die Frist, bis wann dies möglich ist.
        Nach Ablauf der Frist können nur noch Admins Abmeldungen ändern.
      </p>
      <form @submit.prevent="save">
        <div class="row g-3 mb-3">
          <div class="col-md-4">
            <label class="form-label" for="periodStart">Planungszeitraum Start</label>
            <input id="periodStart" v-model="form.period_start" class="form-control" type="date" required>
          </div>
          <div class="col-md-4">
            <label class="form-label" for="periodEnd">Planungszeitraum Ende</label>
            <input id="periodEnd" v-model="form.period_end" class="form-control" type="date" required>
          </div>
          <div class="col-md-4">
            <label class="form-label" for="deadline">Eintragungsfrist</label>
            <input id="deadline" v-model="form.deadline" class="form-control" type="date" required>
          </div>
        </div>
        <div class="d-flex gap-2">
          <button class="btn btn-primary" type="submit" :disabled="saving">Speichern</button>
          <button v-if="window" class="btn btn-outline-danger" type="button" :disabled="saving" @click="clear">
            Fenster löschen
          </button>
        </div>
        <div v-if="errorMsg" class="alert alert-danger mt-3 mb-0">{{ errorMsg }}</div>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SelfServiceWindowSettings',
  data() {
    return {
      window: null,
      form: {period_start: '', period_end: '', deadline: ''},
      saving: false,
      errorMsg: null,
    };
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return '';
      const [y, m, d] = dateStr.split('-');
      return `${d}.${m}.${y}`;
    },
    async load() {
      const response = await this.axios.get('/selfservice/window/');
      if (response.data.deadline) {
        this.window = response.data;
        this.form = {
          period_start: response.data.period_start,
          period_end: response.data.period_end,
          deadline: response.data.deadline,
        };
      }
    },
    async save() {
      this.saving = true;
      this.errorMsg = null;
      try {
        const response = await this.axios.put('/selfservice/window/', this.form);
        this.window = response.data;
      } catch (e) {
        this.errorMsg = 'Speichern fehlgeschlagen. Bitte alle Felder prüfen.';
      } finally {
        this.saving = false;
      }
    },
    async clear() {
      if (!confirm('Selbstservice-Fenster wirklich löschen?')) return;
      this.saving = true;
      this.errorMsg = null;
      try {
        await this.axios.delete('/selfservice/window/');
        this.window = null;
        this.form = {period_start: '', period_end: '', deadline: ''};
      } catch (e) {
        this.errorMsg = 'Löschen fehlgeschlagen.';
      } finally {
        this.saving = false;
      }
    },
  },
  mounted() {
    this.load();
  },
};
</script>
